import { lazy, Suspense } from "react";

export { ToastProvider, useAddToast } from "./ToastProvider.tsx";

const LazyToasts = lazy(() => import("./Toasts"));

export const Toasts = () => (
  <Suspense fallback={null}>
    <LazyToasts />
  </Suspense>
);
